import React, { useState, useEffect } from "react";
import "../../style/dynamicProperties.css";

export default function DynamicProperties() {
  const [visible, setVisible] = useState(false);
  const [colorChanged, setColorChanged] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleColorChange = () => {
    setColorChanged(!colorChanged);
  };

  return (
    <div className="dynamic-container">
      <h1 className="page-title">Dynamic Properties</h1>

      <div className="dynamic-content">
        <h5>Message will be visible after 5 seconds.</h5>

        <button
          id="colorChange"
          type="button"
          onClick={handleColorChange}
          className={`dynamic-btn ${colorChanged ? "color-changed" : ""}`}
        >
          Color Change
        </button>

        <br />

        {visible && (
          <button
            id="visibleAfter"
            type="button"
            className="dynamic-btn"
          >
            Visible After 5 Seconds
          </button>
        )}
      </div>
    </div>
  );
}